<template>
  <table class="info info--importdata">
    <thead>
      <tr>
        <th>Navn</th>
        <th>Dato for afregistrering</th>
        <th />
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, itemIndex) in list"
        :key="itemIndex"
      >
        <td>
          {{ item.name }}
        </td>
        <td v-if="item.changeDate">
          {{ item.changeDate | HumanDate }}
        </td>
        <td v-else>
          Ingen dato
        </td>
        <td class="textRight">
          <a
            href="#"
            @click.prevent="$emit('click', item)"
            class="underline"
          >Opret version</a>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import HumanDate from '../../filters/HumanDate';

export default {
    name: 'ImportPreparationDeletedList',
    props: {
        list: { type: Array, required: true },
    },
    filters: {
        HumanDate,
    },
};
</script>

<style lang="scss" scoped>
.textRight {
    text-align: right;
}
</style>
